import { render } from "./BlockEditorDraggablePrefix.vue?vue&type=template&id=2e509d2c"
import script from "./BlockEditorDraggablePrefix.vue?vue&type=script&lang=js"
export * from "./BlockEditorDraggablePrefix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__